import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05ee8f69"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Qr code", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Preserve system apps:", -1))

import type { Ref } from 'vue'
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import { EnrollmentTokenSchema, MdmPolicySchema } from '@/generated/sdk'
import QrCodeRender from 'qrcode'


export default /*#__PURE__*/_defineComponent({
  __name: 'QrCode',
  props: {
    policy: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore()



const enrollmentToken: Ref<EnrollmentTokenSchema> = ref(null)
const canvas: Ref<HTMLCanvasElement> = ref(null)
const systemApps = ref(true)
const loading = ref(false)

onMounted(() => {
  renderQr()
})

const qrString = computed(() =>
  enrollmentToken.value?.qrCode
    ? JSON.stringify(JSON.parse(enrollmentToken.value.qrCode), null, 2)
    : null,
)

async function renderQr(): Promise<void> {
  loading.value = true

  enrollmentToken.value = await store.dispatch('createEnrollmentToken', {
    mdmPolicy: props.policy,
    systemApps: systemApps.value,
  })

  await QrCodeRender.toCanvas(
    canvas.value,
    enrollmentToken.value?.qrCode,
    { toSJISFunc: QrCodeRender.toSJIS },
  )

  loading.value = false
}

async function sync(): Promise<void> {
  try {
    await store.dispatch('sync', {
      mdmPolicy: props.policy,
      preserveSystemApps: systemApps.value,
    })
    alert('Synced successfully')
  } catch (e: any) {
    console.log(e.message)
    if (e.message?.includes('No api connection found')) {
      const url = await store.dispatch('tempAuthUrl')
      localStorage.setItem('returnPath', location.pathname)
      location.href = url
    } else {
      alert('Error syncing: ' + (e.message || 'Unknown error'))
      throw e
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_PrimeSkeleton = _resolveComponent("PrimeSkeleton")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!

  return (_openBlock(), _createBlock(_component_DodoColumn, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_DodoRow, { gap: "4" }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_InputSwitch, {
            modelValue: systemApps.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((systemApps).value = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (renderQr()))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DodoButton, {
        color: "info",
        variant: "solid",
        onClick: sync
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Sync with Zero-touch ")
        ]),
        _: 1
      }),
      _createVNode(_component_DodoRow, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_PrimeSkeleton, {
            class: _normalizeClass({ hidden: !loading.value }),
            width: "436px",
            height: "436px"
          }, null, 8, ["class"]),
          _createElementVNode("canvas", {
            ref_key: "canvas",
            ref: canvas,
            class: _normalizeClass({ hidden: loading.value })
          }, null, 2)
        ]),
        _: 1
      }),
      _createVNode(_component_DodoRow, null, {
        default: _withCtx(() => [
          _createElementVNode("pre", null, [
            _createElementVNode("code", null, _toDisplayString(qrString.value), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})